export default __webpack_public_path__ + "static/media/silver_inventory_upgrade_page.7314d632.png";